import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ButtonGeneratorModuleModule } from '../button-generator/button-generator-module.module';
import { MatIcon } from '@angular/material/icon';
import { ButtonVariant } from '../button-generator/button-generator.component';

@Component({
  selector: 'app-about-record-any-data',
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIcon,
    ButtonGeneratorModuleModule],
  templateUrl: './about-record-any-data.component.html',
})
export class AboutRecordAnyDataComponent implements OnInit {
  objectKeys: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: { entity: any; entityLabel?: string },
    readonly dialogReference: MatDialogRef<AboutRecordAnyDataComponent>,
  ) {
  }

  ngOnInit(): void {
    this.objectKeys = Object.keys(this.data.entity);
  }

  protected readonly ButtonVariant = ButtonVariant;
}

